<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="110px">
      <el-form-item label="详细地址：" prop="address">
        <el-autocomplete
          v-model="form.address"
          style="width: 100%"
          popper-class="autoAddressClass"
          :fetch-suggestions="querySearchAsync"
          :trigger-on-focus="false"
          placeholder="详细地址"
          clearable
          @select="handleSelect"
        >
          <template slot-scope="{ item }">
            <i class="el-icon-search fl mgr10" />
            <div style="overflow: hidden">
              <div class="title">{{ item.title }}</div>
              <span class="address ellipsis">{{ item.address }}</span>
            </div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="地图定位：">
        <div id="map-container" style="width: 100%; height: 43vh" />
      </el-form-item>
      <el-form-item> </el-form-item>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import loadBMap from "@/utils/loadBMap.js";
export default {
  props: ["bMapRes"],
  data() {
    return {
      BMap: null,
      form: {
        address: "", // 详细地址
        addrPoint: {
          // 详细地址经纬度
          lng: 0,
          lat: 0,
        },
      },
      // lat: 23.148614488154006,
      // lng: 113.33667068937726,
      lat: 0,
      lng: 0,
      map: "", // 地图实例
      mk: "", // Marker实例
      list: [],
      point: null,
    };
  },
  async mounted() {
    await loadBMap("oW2UEhdth2tRbEE4FUpF9E5YVDCIPYih"); // 加载引入BMap
    this.initMap();
    // const _this = this
    // window.initBaiduMapScript = () => {
    //   _this.BMap = window.BMap
    // }
    // loadBMap('initBaiduMapScript')
    // this.getLocation()
  },
  methods: {
    // 初始化地图
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", { enableMapClick: false });
      if (this.bMapRes != undefined) {
        that.form.address = this.bMapRes.address;
        var point = new BMap.Point(this.bMapRes.lng * 1, this.bMapRes.lat * 1);
      } else {
        var point = new BMap.Point();
        //  6、浏览器定位
        // this.geolocation();
      }

      this.map.centerAndZoom(point, 19);
      this.map.enableScrollWheelZoom(true);
      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, { enableDragging: true });
      this.map.addOverlay(this.mk);
      this.mk.addEventListener("dragend", function (e) {
        that.getAddrByPoint(e.point);
      });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
        new BMap.NavigationControl({
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          type: BMAP_NAVIGATION_CONTROL_LARGE,
        })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT,
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);

      // 6、浏览器定位
      this.geolocation();

      // 7、绑定点击地图任意点事件
      this.map.addEventListener("click", function (e) {
        that.getAddrByPoint(e.point);
      });
    },
    // 浏览器定位函数
    geolocation() {
      var that = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function (res) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            that.getAddrByPoint(res.point);
          } else {
            res.point.lat = 39.915095185635316;
            res.point.lng = 116.40397079994426;
            that.getAddrByPoint(res.point);

            // that.$alert(this.getStatus(), "提示", {
            //   confirmButtonText: "确定",
            //   type: "warning",
            //   center: true,
            //   callback: action => {
            //   }
            // });

            if (res.point) {
              res.point.lat = 39.915095185635316;
              res.point.lng = 116.40397079994426;
              that.getAddrByPoint(res.point);
            } else {
              let form = {
                lat: 39.915095185635316,
                lng: 116.40397079994426,
              };
              that.getAddrByPoint(form);
            }
          }
        },
        { enableHighAccuracy: true }
      );
    },
    // 2、逆地址解析函数
    getAddrByPoint(point) {
      var that = this;
      var geco = new BMap.Geocoder();
      geco.getLocation(point, function (res) {
        that.$emit("getAddrByPoint", res);
        that.form = res;
        that.mk.setPosition(point);
        that.map.panTo(point);
      });
    },
    // 8-1、地址搜索
    querySearchAsync(str, cb) {
      var options = {
        onSearchComplete: function (res) {
          var s = [];
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < res.getCurrentNumPois(); i++) {
              s.push(res.getPoi(i));
            }
            cb(s);
          } else {
            cb(s);
          }
        },
      };
      var local = new BMap.LocalSearch(this.map, options);
      local.search(str);
    },
    // 8-2、选择地址
    handleSelect(item) {
      this.form.address = item.address + item.title;
      this.form.addrPoint = item.point;
      this.list = item;
      this.map.clearOverlays();
      this.mk = new BMap.Marker(item.point);
      this.map.addOverlay(this.mk);
      this.map.panTo(item.point);
    },
    // 获取地理定位
    getLocation() {
      const _this = this;
      _this.geolocation = new BMap.Geolocation();

      if (_this.geolocation) {
        // 开启SDK辅助定位，仅当使用环境为移动web混合开发，且开启了定位sdk辅助定位功能后生效
        _this.geolocation.enableSDKLocation();
        // 开始定位
        this.positioning = true;
        // 倒计时
        this.positioningInterval = setInterval(() => {
          if (this.countDown === 0) {
            this.countDown = 30;
            clearInterval(this.positioningInterval);
          } else {
            this.countDown--;
          }
        }, 1000);
        // 位置选项
        const positionOptions = {
          enableHighAccuracy: true, // 要求浏览器获取最佳结果
          timeout: 30, //    超时时间
          maximumAge: 0, // 允许返回指定时间内的缓存结果。如果此值为0，则浏览器将立即获取新定位结果
        };
        // 获取用户位置信息
        _this.geolocation.getCurrentPosition((position) => {
          // 获取定位结果状态码
          const statusCode = _this.geolocation.getStatus();
          let msg = "由于未知错误而无法检索设备的位置"; // 提示消息
          // 判断结果状态码，为0代表获取成功，读取省市、经纬度
          switch (statusCode) {
            case 0:
              msg = "获取地理位置定位请求成功";
              if (position) {
                // 数据变量定义
                let lat = 0.0; // 经度
                let lng = 0.0; // 纬度
                let province = "未知"; // 经度
                let city = "未知"; // 纬度

                // 坐标
                if (position.point) {
                  lat = position.point.lat;
                  lng = position.point.lng;
                }
                // 位置
                if (position.address) {
                  province = position.address.province;
                  city = position.address.city;
                }
                _this.location = {
                  省份: province,
                  城市: city,
                  经度: lat,
                  纬度: lng,
                };
                //console.log(position);
                _this.point = position.point;
              } else {
                msg = "由于未知错误而无法检索设备的位置";
              }
              break;
            case 2:
              msg = "由于未知错误而无法检索设备的位置";
              break;
            case 4:
            case 5:
              msg = "位置服务请求非法";
              break;
            case 6:
              msg = "应用程序没有使用位置服务的权限";
              break;
            case 7:
              msg = "网络不可用或者无法连接到获取位置信息的卫星";
              break;
            case 8:
              msg = "无法在指定的最大超时间隔内检索位置信息";
              break;
            default:
              msg = "由于未知错误而无法检索设备的位置";
              break;
          }
          _this.$message.info({ message: msg });
        }, positionOptions);
      } else {
        that.$alert("您的浏览器不支持定位", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
          callback: (action) => {},
        });
      }
    },
  },
  // 重置定位相关数据
  resetPositioning() {
    this.positioning = false;
    this.location = null;
    this.countDown = 30;
    clearInterval(this.positioningInterval);
  },
};
</script>

<style>
.el-icon-location-information {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/baiduMap/BMap.vue